import { Text } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight } from '~/utils'

export const Title = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {},
  }
})
